<template>
  <b-modal id="add-hog-modal" title="กำหนดประธานหน่วยงาน" @ok="submit" @hidden="clearForm">
    <b-alert variant="primary" show>
      <font-awesome-icon icon="info-circle" /> กรอกชื่อผู้ใช้งาน (Username) ของบัญชีที่ต้องการเพิ่มให้เป็นประธานหน่วยงานนี้
    </b-alert>
    <b-form-group label-cols="4" label-cols-lg="3" label="ชื่อผู้ใช้" label-for="input-default">
      <b-form-input v-model="form.userId" />
    </b-form-group>
  </b-modal>
</template>
<script>
import gql from 'graphql-tag'

export default {
  data () {
    return {
      form: {
        userId: ''
      }
    }
  },
  methods: {
    async submit () {
      await this.$apollo.mutate({
        mutation: gql`mutation ($id: ID!, $username: String!) { groupSetHeadOfGroup(id: $id, username: $username) { id } }`,
        variables: { id: this.$route.params.id, username: this.form.userId }
      }).then(async () => {
        this.$bvToast.toast('กำหนดประธานหน่วยงานสำเร็จ', {
          title: 'สำเร็จ',
          variant: 'success',
          solid: true
        })
      }).catch(() => {
        this.$bvToast.toast('เกิดข้อผิดพลาดในการบันทึกข้อมูล ตรวจสอบการกรอกข้อมูลอีกครั้ง', {
          title: 'แจ้งเตือน',
          variant: 'danger',
          solid: true
        })
      })

      this.$emit('finish')
    },
    clearForm () {
      this.form = {
        userId: ''
      }
    }
  }
}
</script>
